import { compose, withProps } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { parse } from "query-string";
import { withActions } from "core/redux/hoc";
import * as paymentSelectors from "modules/payment/selectors";
import * as paymentApi from "modules/payment/api";
import * as paymentActions from "modules/payment/actions";
import View from "./View";

export default compose(
  withRouter,
  connect(
    createStructuredSelector({
      defaultCardId: paymentSelectors.getDefaultCardId,
      checkoutApi: paymentSelectors.checkoutApi,
      isFormVisible: paymentSelectors.isCreateFormVisible,
      deletingCardId: paymentSelectors.getDeletingCardId
    })
  ),
  withActions({
    onSubmit: ({ location }) => data =>
      paymentApi.checkout.request({
        bookingId: parse(location.search).bookingId,
        cardId: data.card,
        promo_code: parse(location.search).coupon
      }),
    deleteCard: () => id => paymentApi.deleteCard.request(id),
    showForm: () => () => paymentActions.showCreateForm(),
    hideForm: () => () => paymentActions.hideCreateForm()
  }),
  withProps(({ defaultCardId }) => ({
    initialValues: {
      card: defaultCardId + ""
    }
  }))
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/components/Cards/Provider.js